import { render, staticRenderFns } from "./SelectableTab.vue?vue&type=template&id=0a97b756&scoped=true&"
import script from "./SelectableTab.vue?vue&type=script&setup=true&lang=ts&"
export * from "./SelectableTab.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./SelectableTab.vue?vue&type=style&index=0&id=0a97b756&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a97b756",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0a97b756')) {
      api.createRecord('0a97b756', component.options)
    } else {
      api.reload('0a97b756', component.options)
    }
    module.hot.accept("./SelectableTab.vue?vue&type=template&id=0a97b756&scoped=true&", function () {
      api.rerender('0a97b756', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "www/vue_components/common/SelectableTab/SelectableTab.vue"
export default component.exports